module.exports = __webpack_public_path__ + "static/media/datasheet_topScorerData_row0_certificate1.0fdde14a.png";